import React from 'react';
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';

// MUI's LinearProgress renders an element with role="progressbar". Lighthouse
// (axe rule `aria-progressbar-name`) flags it as unnamed without an aria
// label. This is the canonical loading-bar used as Suspense fallback across
// the app, so an aria-label default fixes a11y at every call site.
const LinearProgressComponent = ({ label = 'Loading' }) => {
  return (
    <Stack sx={{ width: '100%' }} spacing={2}>
      <LinearProgress aria-label={label} />
    </Stack>
  );
};

export default LinearProgressComponent;
